import validator from 'validator';
import { isNullOrUndefinedOrEmpty } from '../helpers/common';
import { isRfpOfferMemberTypeCompany, isRfpOfferMemberTypeOutside, } from '../helpers/rfp';
import { validateSelected, validateEmail, validateLastName, validateFirstName, } from './common';
import { isRequiredText, strMax, isNotIncludedEmailDomain, isIncludedEmailDomain, } from './utils';
export const validateRfpOfferMemberModal = {
    companyName: [
        isRequiredText('企業名を入力してください'),
        strMax(50, '企業名は50文字以内で入力してください'),
    ],
    companyUrl: [
        strMax(255, 'HPのURLは255文字以内で入力してください'),
        (value) => {
            if (isNullOrUndefinedOrEmpty(value) || validator.isURL(value)) {
                return '';
            }
            return 'HPのURLを入力してください';
        },
    ],
    email: [
        ...validateEmail,
        (value, record, props) => {
            const { rfpOfferMembers } = props;
            return rfpOfferMembers.some((v) => v.email === value)
                ? '既にメンバー体制に登録されているメールアドレスです'
                : '';
        },
        (value, record, props) => {
            const { memberType } = record;
            const { enableDomains } = props;
            if (isRfpOfferMemberTypeCompany(memberType)) {
                return isNotIncludedEmailDomain(enableDomains, '社内メンバーでしょうか？ドメインが異なりますので、社外の場合は【共同提案メンバー（社外）】から追加ください')(value);
            }
            if (isRfpOfferMemberTypeOutside(memberType)) {
                return isIncludedEmailDomain(enableDomains, '社外メンバーでしょうか？同じドメインですので、社内の場合は【社内メンバー】から追加ください')(value);
            }
            return '';
        },
    ],
    firstName: validateFirstName,
    inviteRole: validateSelected,
    lastName: validateLastName,
    memberType: validateSelected,
};
export const validateRfpOnlineQuestion = [
    isRequiredText('質問内容を入力してください'),
    strMax(2000, '2000文字以内で入力してください'),
];
